import { Fragment, useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../components/common/sidebar/sidebar';
import Header from '../components/common/header/header';
import Footer from '../components/common/footer/footer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Provider } from "react-redux";
import store from '../redux/store';
import Switcher from '../components/common/switcher/switcher';
import TabToTop from '../components/common/tabtotop/tabtotop';
import Pageheader from '../components/pageheader/pageheader';

function App() {
  const navigate = useNavigate();
  const [lateLoad, setlateLoad] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Verificar autenticación al cargar la aplicación
    const checkAuthentication = () => {
      try {
        const token = localStorage.getItem('token');
        const usuario = localStorage.getItem('usuario');
        const isAuthenticated = localStorage.getItem('isAuthenticated');
        
        console.log('🔐 [APP] Verificando autenticación:', {
          hasToken: !!token,
          hasUser: !!usuario,
          isAuthenticated
        });

        // Si no hay datos de autenticación, redirigir al login
        if (!token || !usuario || isAuthenticated !== 'true') {
          console.log('🔐 [APP] No autenticado, redirigiendo al login');
          localStorage.removeItem('token');
          localStorage.removeItem('usuario');
          localStorage.removeItem('isAuthenticated');
          navigate('/login', { replace: true });
          return;
        }

        console.log('🔐 [APP] Usuario autenticado correctamente');
        setAuthChecked(true);
        setlateLoad(true);
      } catch (error) {
        console.error('🔐 [APP] Error verificando autenticación:', error);
        navigate('/login', { replace: true });
      }
    };

    checkAuthentication();
  }, [navigate]);

  // Si aún no se ha verificado la autenticación, mostrar loading
  if (!authChecked) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#f8f9fa' 
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #007bff',
            borderRadius: '50%',
            width: '40px',
            height: '40px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p>Verificando autenticación...</p>
        </div>
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <Fragment>
      <Provider store={store}>
      <div style={{display: `${lateLoad ? 'block' : 'none'}`}}>
        <HelmetProvider>
          <Helmet
            htmlAttributes={{
              lang: "en",
              dir: "ltr",
              "data-menu-styles": "dark",
              "data-theme-mode": "light",
              "data-nav-layout": "vertical",
              "data-header-styles": "light",
              "data-vertical-style": "overlay",
              "data-loader": "disable",
              
            }}
          />
          <Switcher />
          <div className='page'>
            <Header />
            <Sidebar />
            <Pageheader />
            <div className='main-content app-content' 
            >
              <div className='container-fluid'>
                <Outlet />
              </div>
            </div>
          
          <Footer />
          </div>
          <TabToTop />
        </HelmetProvider>
        </div>
      </Provider>
    </Fragment>
  );
}

export default App;
